import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core'
import _ from 'lodash';

export const PhoneEdit = (props) => {
  // Requires {editData: {phone number, ctc number, pax number}, rloc, type, airlineId}
  const pax = props.pax
  const changeData = props.changeData
  const [phone, setPhone] = useState(pax.phone || '')
  const ctcNumber = pax.ctcNumber || ''

  // NOTE // on changing the selected passenger, or closing and opening the edit tab, revert the data
  useEffect(() => {
    let paxPhone = pax.phone ? pax.phone : ''
    paxPhone = paxPhone.split(' ').join('')
    paxPhone = paxPhone.split('(').join('')
    paxPhone = paxPhone.split(')').join('')
    paxPhone = paxPhone.split('+').join('')
    setPhone(paxPhone)
    changeData('', 'phone')
  }, [pax]);

  const handleSetPhone = (data) => {
    setPhone(data)
    // TODO // should we add in req's for phone numbers? (i.e. minimum of 10 numbers)
    let dataCopy = _.clone(data)
    // NOTE // splitting on '-' to remove them, then joining them back into a string (same for spaces and parenthases below)
    dataCopy = dataCopy.split('-').join('')
    dataCopy = dataCopy.split(' ').join('')
    dataCopy = dataCopy.split('(').join('')
    dataCopy = dataCopy.split(')').join('')
    dataCopy = dataCopy.split('+').join('')
    dataCopy = dataCopy.split(',').join('')
    // NOTE // if all that's left is just numbers, save it
    if (dataCopy.match(/^\d+$/) !== null) {
      // TODO // on the back-end the editData.ctcNumber property takes precedence over editData.phoneNumber. I don't think original fb had a way to edit ctc numbers, but idk
      changeData({editData: {phoneNumber: dataCopy, ctcNumber: ctcNumber, paxNumber: pax.PaxNumber}, rloc: pax.PNRRefNo, type: 'editPhone', airlineId: ''}, 'phone')
    }
  }

  return (
    <Grid container justifyContent="center" item xs={12}>
      <TextField
        id="phone"
        label="Phone Number"
        type="text"
        disabled={!pax}
        value={phone}
        InputLabelProps={{ shrink: true }}
        style={{width: '90%'}}
        onChange={(e) => {handleSetPhone(e.target.value)}}
      />
    </Grid>
  )
}

export const WeightEdit = (props) => {
  // Requires {editData: {weight, pax number}, rloc, type, and airlineId}
  const pax = props.pax
  const changeData = props.changeData
  const [weight, setWeight] = useState(pax.Weight ? pax.Weight.split('L')[0] : '')

  // NOTE // on changing the selected passenger, or closing and opening the edit tab, revert the data
  useEffect(() => {
    setWeight(pax.Weight ? pax.Weight.split('L')[0] : '')
    changeData('', 'weight')
  }, [pax]);

  const handleSetWeight = (data) => {
    setWeight(data)
    // NOTE // videcom keeps weights like '135LBS', so add 'LBS' in when throwing the data back to EditPaxModal
    changeData({editData: {weight: (data + 'LBS'), paxNumber: pax.PaxNumber}, rloc: pax.PNRRefNo, type: 'editWeight', airlineId: ''}, 'weight')
  }

  return (
    <Grid container justifyContent="center" item xs={12}>
      <TextField
        id="weight"
        label="Pax Weight"
        type="number"
        value={weight}
        disabled={!pax}
        InputLabelProps={{ shrink: true }}
        style={{width: '90%'}}
        onChange={(e) => {handleSetWeight(e.target.value)}}
      />
    </Grid>
  )
}

export const AddRemark = (props) => {
  // Requires {editData: {comment}, rloc, type, and airlineId}
  const modalClasses = props.modalClasses
  const pax = props.pax
  const changeData = props.changeData
  const [remark, setRemark] = useState('')

  const handleSetRemark = (data) => {
    setRemark(data)
    // NOTE // videcom keeps weights like '135LBS', so add 'LBS' in when throwing the data back to EditPaxModal
    changeData({editData: {comment: data}, rloc: pax.PNRRefNo, type: 'addRemark', airlineId: ''}, 'remark')
  }

  return (
    <Grid container justifyContent="center" item lg={12} xs={12}>
      {!pax ? 
        <Grid container justifyContent="center" item xs={11} className={modalClasses.instructionText}>
          <span>You need to select a passenger to add a remark</span>
        </Grid> :
        <div></div>
      }
      <TextField
        id="add-remark"
        label="Add Remark"
        type="text"
        multiline
        rows={1}
        variant="filled"
        value={remark}
        disabled={!pax}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => {handleSetRemark(e.target.value)}}
        style={{width: '65%'}}
      />
    </Grid>
  )
}